// extracted by mini-css-extract-plugin
export default {"bread":"bread_bread__xjmft"};